module.exports = __webpack_public_path__ + "static/media/cli.c718cdf1.svg";